import { render, staticRenderFns } from "./turnover-view.vue?vue&type=template&id=09c69c68&scoped=true&"
import script from "./turnover-view.vue?vue&type=script&lang=ts&"
export * from "./turnover-view.vue?vue&type=script&lang=ts&"
import style0 from "./turnover-view.vue?vue&type=style&index=0&id=09c69c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c69c68",
  null
  
)

export default component.exports